// extracted by mini-css-extract-plugin
export default {"searchBox":"bp_kq","resultsOpen":"bp_kr"};